<template>
  <div class="home" v-loading="loading">
    <div class="The-first-half flex ju-sp al-cn">
      <img class="image" src="@/assets/home-img/Freehand-painting1.png">
      <div class="rightSide">
        <div class="rightSide-item flex al-cn" v-for="(item,index) in list" :key="index" @click="to(item.path)">
          <img class="icon" :src="item.icon"/>
          <div class="name font-bold">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <The-second-half></The-second-half>
  </div>
</template>

<script>

import TheSecondHalf from "@/components/The-second-half.vue";

export default {
  name: "HelloWorld",
  components: {TheSecondHalf},
  data() {
    return {
      loading: false,
      list: [
        {
          name: 'mindfulness exercises',
          icon: require('@/assets/home-img/mindfulness-exercises.png'),
          path: 'mindfulness-exercises'
        }, {
          name: 'mind steps',
          icon: require('@/assets/home-img/mind-steps.png'),
          path: 'mind-steps'
        }, {
          name: 'podcast episodes',
          icon: require('@/assets/home-img/podcast-episodes.png',),
          path: 'podcast-episodes'
        }, {
          name: 'online courses',
          icon: require('@/assets/home-img/online-courses.png'),
          path: 'mindfulness-youth'
        }, {
          name: 'store',
          icon: require('@/assets/home-img/store.png'),
          path: 'mindfulness-journal'
        },
      ],
      /*softwareList: [
        {
          text: 'Instagram',
          icon: require('../assets/home-img/Instagram.png')
        },
        {
          text: 'spotify podcast',
          icon: require('../assets/home-img/spotify-podcast.png')
        },
        {
          text: 'tiktok',
          icon: require('../assets/home-img/tiktok.png')
        },
        {
          text: 'shopify',
          icon: require('../assets/home-img/shopify.png')
        }
      ],*/
    };
  },
  created() {

  },

  computed: {},
  mounted() {

  },
  methods: {
    to(path) {
      if (path) {
        this.$router.push({name: path});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.home {

  .The-first-half {
    background-image: url("@/assets/home-img/YellowMosaic.png");
    background-repeat: no-repeat;
    background-size: cover;

    .image {
      width: 1057px;
      height: 607px;
      margin: 23px 24px 19px 0;
    }

    .rightSide {
      background-color: #fff;
      //border: 2px solid #705B4E;
      border-radius: 25px;
      width: 490px;
      height: 540px;
      padding: 20px;
      margin-right: 30px;

      &-item {
        //border: 2px solid #6A5948;
        background-color: #F6F6C0;
        padding: 18px 26px;
        margin: 0 auto 15px auto;
        border-radius: 25px;

        .icon {
          width: 60px;
          height: 60px;
        }

        .name {
          font-size: 25px;
          color: #262626;
          text-align: center;
          width: 100%;
        }

        //鼠标移入
        &:hover {
          cursor: pointer;//鼠标移入变小手
          background-color: #f5d197;
        }
      }
    }
  }
}

</style>
